'use strict';

const calendar = [
  '$filter',

  function ($filter) {
    var dateFilter = $filter('date');

    function getCalendarHeader(date) {
      return dateFilter(date , 'MMMM yyyy');
    }

    function getDaysInMonth(date) {
      return new Date(2014, (date.getMonth() + 1) % 12, 0).getDate();
    }

    function getDayOfTheWeek(date) {
      return (date.getDay() + 7) % 7;
    }

    function formatDate(date) {
      return dateFilter(date , 'yyyyMMdd');
    }

    function stringToDate(dateString) {
      var year = parseInt(dateString.substr(0, 4), 10);
      var month = parseInt(dateString.substr(4, 2), 10) - 1;
      var day = parseInt(dateString.substr(6, 2), 10);

      return new Date(year, month, day);
    }

    function getMonth(monthDate, minDate, maxDate, disabledDates) {
      var daysInMonth = getDaysInMonth(monthDate);
      var dayOfWeek = getDayOfTheWeek(monthDate);
      var month = [];
      var iter;
      var total;
      var week;

      disabledDates = disabledDates || [];

      function getDay(date) {
        var day = {
          dayOfMonth: date.getDate(),
          fullDate: formatDate(date)
        };

        if (date < minDate || date > maxDate || date.getMonth() !== monthDate.getMonth() || disabledDates.indexOf(day.fullDate) > -1) {
          day.isDisabled = true;
        }

        return day;
      }

      total = 6 - getDayOfTheWeek(new Date(monthDate.getFullYear(), monthDate.getMonth(), daysInMonth)) + daysInMonth;
      for (iter = 1 - dayOfWeek; iter <= total; iter++) {
        if (!week || week.length === 7) {
          week = [];
          month.push(week);
        }

        week.push(getDay(new Date(monthDate.getFullYear(), monthDate.getMonth(), iter)));
      }

      return month;
    }

    function getCalendar(selectedDate, disabledDates, minDateParam, maxDateParam) {
      var now = new Date();
      var minDate = minDateParam || new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var maxDate = maxDateParam || new Date(minDate.getFullYear() + 1, minDate.getMonth(), minDate.getDate());
      var year = minDate.getFullYear();
      var month = minDate.getMonth();
      var calendar = {
        headers: [],
        months: [],
        today: formatDate(now)
      };
      var selectedDateObj = selectedDate && stringToDate(selectedDate) || now;
      var monthDate;

      if (selectedDateObj < new Date(now.getFullYear(), now.getMonth(), now.getDate())) {
        selectedDateObj = now;
      }

      calendar.selectedDate = formatDate(selectedDateObj);

      for (monthDate = new Date(year, month, 1); monthDate.getTime() <= maxDate.getTime(); monthDate = new Date(year, ++month, 1)) {
        calendar.headers.push(getCalendarHeader(monthDate));
        calendar.months.push(getMonth(monthDate, minDate, maxDate, disabledDates));

        if (selectedDateObj.getFullYear() === monthDate.getFullYear() && selectedDateObj.getMonth() === monthDate.getMonth()) {
          calendar.currentMonth = calendar.months.length - 1;
        }
      }

      return calendar;
    }

    return {
      getCalendar: getCalendar,
    };
  }
];

export default calendar;



// WEBPACK FOOTER //
// ./app/src/services/calendar.js